// Component: Speaker
// Author: Vijay Radhakrishnan

import * as React from 'react';
import { useEffect } from 'react';
import SpeakerComponent from '@component/Speaker';
import i18n from 'i18next';
import { Text, withSitecoreContext, RichText, withPlaceholder } from '@sitecore-jss/sitecore-jss-react';

const Speaker = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  let Button = false;
  if (props.fields?.Button?.value?.href) {
    /*
     If link is present in bio but not the text for link,
     fall back on term/learnmore dictionary item
    */
    let buttonText = i18n.t('term/learnmore');
    if (props.fields?.Button?.value?.text) {
      buttonText = props.fields?.Button?.value?.text;
    }
    Button = (
      <a href={props.fields?.Button?.value?.href} target={props.fields?.Button?.value?.target}>
        {buttonText}
      </a>
    );
  }

  let SpeakerData = {
    Image: <img src={props.fields?.Image.value.src} alt={props.fields?.Image?.value?.alt} />,
    Name: <Text field={props.fields?.Name} />,
    Title: <Text field={props.fields?.Title} />,
    Club: <Text field={props.fields?.Club} />,
    Location: <Text field={props.fields?.Location} />,
    Bio: <RichText field={props.fields?.Bio} />,
    Button: Button,
  };
  return (
    <>
      <SpeakerComponent {...SpeakerData} />
    </>
  );
};

const compWithPlaceholder = withPlaceholder('Speaker-Grid-Card')(Speaker);
const compWithSitecoreCtx = withSitecoreContext()(compWithPlaceholder);

export default compWithSitecoreCtx;
